module.exports = __webpack_public_path__ + "img/grupo-abril.29bbc26d.svg";